import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
const STEPS = [
  { key: "placed", label: "Order Placed" },
  { key: "shipped", label: "Shipped" },
  { key: "out_for_delivery", label: "Out for delivery" },
  { key: "delivered", label: "Delivered" }
];
const OFF_LADDER_PILL = {
  processing: { label: "Processing Order", color: "#D97706", bg: "#FFFBEB" },
  cancelled: { label: "Cancelled", color: "#DC2626", bg: "#FEF2F2" },
  returned: { label: "Returned", color: "#7C3AED", bg: "#F5F3FF" },
  unknown: { label: "Unknown", color: "#6B7280", bg: "#F9FAFB" }
};
function getStepIndex(status) {
  const idx = STEPS.findIndex((s) => s.key === status);
  return idx >= 0 ? idx : -1;
}
const OrderWidget = ({ data }) => {
  const { orderId, items, status, eta, trackingUrl, carrier } = data;
  const activeIdx = getStepIndex(status);
  const offLadderPill = OFF_LADDER_PILL[status];
  const isOffLadder = offLadderPill !== void 0;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 480,
        maxHeight: "100%",
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 16,
        padding: "18px 18px 14px",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
        overflowY: "auto"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 14
            },
            children: [
              /* @__PURE__ */ jsxs("div", { children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                      color: "var(--voice-widget-muted, #6B7280)",
                      marginBottom: 2
                    },
                    children: "Order"
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { fontSize: 15, fontWeight: 700, color: "var(--voice-widget-fg, #111827)" }, children: [
                  "#",
                  orderId
                ] })
              ] }),
              !isOffLadder && /* @__PURE__ */ jsxs("div", { style: { textAlign: "right" }, children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      fontSize: 11,
                      color: "var(--voice-widget-muted, #6B7280)",
                      marginBottom: 2
                    },
                    children: "Arriving"
                  }
                ),
                /* @__PURE__ */ jsx("div", { style: { fontSize: 13, fontWeight: 600, color: "var(--voice-widget-fg, #111827)" }, children: eta })
              ] }),
              isOffLadder && offLadderPill && /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    fontSize: 12,
                    fontWeight: 600,
                    color: offLadderPill.color,
                    background: offLadderPill.bg,
                    padding: "3px 10px",
                    borderRadius: 999
                  },
                  children: offLadderPill.label
                }
              )
            ]
          }
        ),
        !isOffLadder && /* @__PURE__ */ jsxs("div", { style: { marginBottom: 14 }, children: [
          /* @__PURE__ */ jsx("div", { style: { display: "flex", alignItems: "center", position: "relative" }, children: STEPS.map((step, i) => {
            const done = i <= activeIdx;
            const active = i === activeIdx;
            return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: done ? "var(--voice-widget-accent, #7DD3C0)" : "var(--voice-widget-border, #E5E7EB)",
                    border: active ? "3px solid var(--voice-widget-accent, #7DD3C0)" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    zIndex: 1,
                    boxSizing: "border-box",
                    transition: "background 200ms ease-out"
                  },
                  children: done && /* @__PURE__ */ jsx("svg", { width: "11", height: "9", viewBox: "0 0 11 9", fill: "none", children: /* @__PURE__ */ jsx("path", { d: "M1 4l3 3 6-6", stroke: "white", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }) })
                }
              ),
              i < STEPS.length - 1 && /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    flex: 1,
                    height: 3,
                    background: i < activeIdx ? "var(--voice-widget-accent, #7DD3C0)" : "var(--voice-widget-border, #E5E7EB)",
                    transition: "background 200ms ease-out"
                  }
                }
              )
            ] }, step.key);
          }) }),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                marginTop: 6
              },
              children: STEPS.map((step, i) => /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    fontSize: 10,
                    fontWeight: i === activeIdx ? 700 : 400,
                    color: i <= activeIdx ? "var(--voice-widget-accent-dark, #0D9488)" : "var(--voice-widget-muted, #6B7280)",
                    textAlign: "center",
                    width: 48,
                    lineHeight: 1.2
                  },
                  children: step.label
                },
                step.key
              ))
            }
          )
        ] }),
        items.slice(0, 2).map((item, i) => /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              gap: 10,
              alignItems: "center",
              marginBottom: 8
            },
            children: [
              item.imageUrl && /* @__PURE__ */ jsx(
                "img",
                {
                  src: item.imageUrl,
                  alt: item.title,
                  style: {
                    width: 40,
                    height: 40,
                    objectFit: "contain",
                    borderRadius: 6,
                    background: "var(--voice-widget-img-bg, #F9FAFB)",
                    flexShrink: 0
                  }
                }
              ),
              /* @__PURE__ */ jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    style: {
                      fontSize: 12,
                      fontWeight: 500,
                      color: "var(--voice-widget-fg, #111827)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    },
                    children: item.title
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { fontSize: 11, color: "var(--voice-widget-muted, #6B7280)" }, children: [
                  "Qty ",
                  item.qty,
                  " · ",
                  item.price
                ] })
              ] })
            ]
          },
          i
        )),
        carrier && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              borderTop: "1px solid var(--voice-widget-border, #E5E7EB)",
              marginTop: 8,
              paddingTop: 10,
              display: "flex",
              alignItems: "center",
              gap: 8
            },
            children: [
              /* @__PURE__ */ jsxs("span", { style: { fontSize: 12, color: "var(--voice-widget-muted, #6B7280)" }, children: [
                "Carrier: ",
                /* @__PURE__ */ jsx("strong", { style: { color: "var(--voice-widget-fg, #111827)" }, children: carrier })
              ] }),
              trackingUrl && /* @__PURE__ */ jsx(
                "a",
                {
                  href: trackingUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  style: {
                    marginLeft: "auto",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "var(--voice-widget-accent-dark, #0D9488)",
                    textDecoration: "none"
                  },
                  children: "Track →"
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  OrderWidget
};
//# sourceMappingURL=OrderWidget.js.map
